module.exports = "/assets/dist/images/sycBannerImage.jpg?7b2b4cfb20e5f1dda29ef9a9be61b178";